module.exports = __webpack_public_path__ + "static/img/sjoa-details.0b1bd87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sjoa-details.png
// module id = GTT1
// module chunks = 0